import store from '@/states/index.js'

import ServiceTypes from '../ServiceTypes'

export default [
    {
        path: '/service_type',
        component: ServiceTypes,
        name: 'service_type',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 1){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]